export const tableauUsers = Object.freeze({
  type: {
    Unlicensed: 'Unlicensed',
    Viewer: 'Viewer',
    Explorer: 'Explorer',
    Site_Administrator_Explorer: 'Site Administrator Explorer',
    Creator: 'Creator',
    Site_Administrator_Creator: 'Site Administrator Creator',
  },
})
